import store from '../../store'
import {createProjectRequest} from '../../actions/projects'

//Takes full project object

export function createProject(project){
	return store.dispatch(createProjectRequest(project))
}
